"use strict";

exports.__esModule = true;
exports.GlitrTracker = void 0;

var _apiCall = _interopRequireDefault(require("../../helpers/apiCall"));

var _trackingIds = require("../data-layer-composer/trackingIds");

var _computedValues = require("../data-layer-composer/computedValues");

var _heartbeat = require("./heartbeat");

var _constants = require("../../config/constants");

var _consentChecker = require("./helpers/consentChecker");

var _lowercasing = require("../../helpers/lowercasing");

var _cookie = require("../../helpers/cookie");

var _detectTestMode = require("../../helpers/detectTestMode");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Main GLiTR tracker class
 * @param whoami values to determine API path
 * @param dataLayer values to enhance the calls with the computed values on firing calls
 * @export
 * @class GlitrTracker
 */
class GlitrTracker {
  constructor(whoami, dataLayer, mhLogger) {
    var _whoami$glitrTracker, _whoami$glitrTracker2;

    _defineProperty(this, "push", message => {
      switch (message.type) {
        case 'pageview':
          this.mhLogger('dl', this.dataLayer);

          if (this.heartbeat && this.enabled) {
            this.heartbeat.reset();
            this.heartbeat.startHeartbeat();
          }

          this.setPreviousPage(message); // console.log('debug pageview');

          return this.sendTrackingBeacon(`${this.uri}/v`, message.type, { ...this.dataLayer,
            ...message,
            ...(0, _trackingIds.getTrackingIds)(),
            ...(0, _computedValues.computedValues)(),
            isnewdataformat: this.legacyDataFormat
          });

        case 'event':
          return this.sendTrackingBeacon(`${this.uri}/e`, message.type, { ...this.dataLayer,
            ...message,
            //to ensure all event properties in lowercase
            ...(0, _lowercasing.convertToLowerCasing)({
              eventaction: message.eventaction,
              eventlabel: message.eventlabel,
              eventtype: message.eventtype
            }),
            ...(0, _trackingIds.getTrackingIds)(true),
            ...(0, _computedValues.computedValues)(),
            isnewdataformat: this.legacyDataFormat
          });

        case 'heartbeat':
          if (this.heartbeat && this.enabled) {
            var _this$dataLayer, _getTrackingIds;

            this.mhLogger('debug hb', this.dataLayer);
            let enrichedProps = {};
            (this.whoami.allowedPropertiesForEnrichment || []).map(key => enrichedProps[key] = this.dataLayer[key]);
            return this.sendTrackingBeacon(`${this.heartbeatUri}/h`, message.type, {
              brandcode: (_this$dataLayer = this.dataLayer) == null ? void 0 : _this$dataLayer.brandcode,
              ...enrichedProps,
              isnewdataformat: this.legacyDataFormat,
              ...message,
              viewid: (_getTrackingIds = (0, _trackingIds.getTrackingIds)(true)) == null ? void 0 : _getTrackingIds.viewid
            });
          }

        case 'stopheartbeat':
          return new Promise((resolve, reject) => {
            if (!this.enabled || !this.heartbeat) {
              reject('Heartbeat not enabled');
            }

            this.heartbeat.stopHeartbeat();
            return resolve();
          });

        case 'stopheartbeat':
          return new Promise((resolve, reject) => {
            if (!this.enabled || !this.heartbeat) {
              reject('Heartbeat not enabled');
            }

            this.heartbeat.stopHeartbeat();
            return resolve();
          });

        default:
          return Promise.reject(new Error('Not a valid message'));
      }
    });

    _defineProperty(this, "sendTrackingBeacon", (uri, type, data) => {
      const preparedData = (0, _consentChecker.consentChecker)(data, this.consentInfo);

      if (typeof window.navigator.sendBeacon !== 'function' || this.testModeEnabled) {
        return this.sendTrackingCall(uri, type, preparedData);
      } // DEBUG BODY


      const entr = new URLSearchParams(this.formatData(data));

      for (let pair of entr.entries()) {
        this.mhLogger(pair[0] + ', ' + pair[1]);
      }

      navigator.sendBeacon(`${uri}`, new URLSearchParams(this.formatData(preparedData)));
      return Promise.resolve();
    });

    _defineProperty(this, "formatData", data => this.legacyDataFormat ? {
      data: JSON.stringify({ ...data,
        testmode: this.testModeEnabled
      }),
      clienttimestamp: new Date().getTime(),
      version: _constants.scriptVersion
    } : { ...data,
      testmode: this.testModeEnabled
    });

    _defineProperty(this, "sendTrackingCall", (uri, type, data) => {
      return (0, _apiCall.default)(`${uri}`, {
        method: 'POST',
        headers: {
          'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
        },
        data: new URLSearchParams(this.formatData(data)),
        onSuccess: response => {// console.log('response.data', response.data);
        },
        onError: () => {
          console.error('err');
        }
      });
    });

    _defineProperty(this, "setPreviousPage", message => {
      localStorage.setItem('previousPath', message.pageurl);
    });

    this.whoami = whoami;
    this.mhLogger = mhLogger;
    localStorage.removeItem('previousPath');
    this.testModeEnabled = (0, _detectTestMode.detectTestMode)((_whoami$glitrTracker = whoami.glitrTracker) == null ? void 0 : _whoami$glitrTracker.enableTestMode);
    this.uri = whoami.glitrTracker.uri;
    this.consentInfo = whoami.glitrTracker.consentInfo;
    this.heartbeatUri = whoami.glitrTracker.heartbeat.uri || whoami.glitrTracker.uri;
    this.dataLayer = dataLayer;
    const {
      enabled,
      lookAroundSpeed,
      defaultTimeOut
    } = whoami.glitrTracker.heartbeat;

    if (enabled) {
      this.enabled = enabled;
      this.heartbeat = new _heartbeat.Heartbeat(defaultTimeOut, lookAroundSpeed, this.push);
    }

    this.legacyDataFormat = ((_whoami$glitrTracker2 = whoami.glitrTracker) == null ? void 0 : _whoami$glitrTracker2.legacyDataFormat) || false;
  }
  /**
   * This determines which type of message needs to be sent to the API
   *
   * @memberof GlitrTracker
   */


}

exports.GlitrTracker = GlitrTracker;